import { LockKeyhole } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

import { useAuth } from "@/components/AuthProvider";
import { api, formatApiError } from "@/lib/api";


export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const response = await api.post("/auth/login", { email, password });
      setUser(response.data);
      navigate(location.state?.from?.pathname || "/dashboard", { replace: true });
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-page" data-testid="login-page">
      <section className="auth-panel" aria-labelledby="login-title">
        <p className="eyebrow">ANEKA / CONTROL DESK</p>
        <LockKeyhole aria-hidden="true" className="auth-icon" size={28} />
        <h1 id="login-title" data-testid="login-title">Masuk ke dashboard</h1>
        <p className="auth-copy" data-testid="login-description">
          Pantau penjualan toko dari satu ruang kerja yang aman.
        </p>
        <form className="auth-form" data-testid="login-form" onSubmit={handleSubmit}>
          <label htmlFor="login-email">Email</label>
          <input
            autoComplete="email"
            data-testid="login-email-input"
            id="login-email"
            onChange={(event) => setEmail(event.target.value)}
            required
            type="email"
            value={email}
          />
          <label htmlFor="login-password">Password</label>
          <input
            autoComplete="current-password"
            data-testid="login-password-input"
            id="login-password"
            minLength="8"
            onChange={(event) => setPassword(event.target.value)}
            required
            type="password"
            value={password}
          />
          {error && <p className="form-error" data-testid="login-error" role="alert">{error}</p>}
          <button data-testid="login-submit-button" disabled={isSubmitting} type="submit">
            {isSubmitting ? "Memproses…" : "Masuk"}
          </button>
        </form>
        <Link data-testid="forgot-password-link" to="/forgot-password">Lupa password?</Link>
      </section>
    </main>
  );
}